import { isMobile } from '@farmasiet/frontendcore-reactcomponents';
import { useEffect, useState } from 'react';
import React from 'react';

import { PictureProfile } from '../../../../ResizedImage/PictureProfile.csharp';
import { getTranslation, keys } from '../../../../Resources/Translations';
import { ResponsivePicture } from '../../ResponsivePicture/ResponsivePicture';
import { CooledProductsConflictItem } from '../CooledProductsConflictItem';
import { Info } from './Info';
import { isRxItem } from './IsRxItem';

interface SingleProductProps {
    product: CooledProductsConflictItem;
    label?: string;
    pictureProfile: PictureProfile;
}

export const SingleProduct = ({ product, label, pictureProfile }: SingleProductProps) => {
    const isRx = isRxItem(product);
    const [isMobileWidth, setIsMobileWidth] = useState(isMobile());

    const onResize = () => {
        setIsMobileWidth(isMobile());
    };

    useEffect(() => {
        setIsMobileWidth(isMobile());

        if (isRx) {
            window?.addEventListener('resize', onResize);
        }

        return () => {
            if (isRx) {
                window?.removeEventListener('resize', onResize);
            }
        };
    }, []);

    return (
        <>
            <div className="CooledProductsConflictEntry__Pictures">
                <div className="CooledProductsConflictEntry__Picture">
                    {isRx && product.imageUrl ? (
                        <iframe src={product.imageUrl} scrolling="no" sandbox="allow-same-origin" />
                    ) : (
                        <ResponsivePicture profile={pictureProfile} model={product.image} />
                    )}
                    {product.isCooled && <div className="CooledProductsConflictEntry__Icon" />}
                </div>
            </div>
            <div className="CooledProductsConflictEntry__Data">
                <div className="CooledProductsConflictEntry__Text">
                    {isRx && product.nameUrl ? (
                        <>
                            <span className="CartItemV2__RxHeading">{getTranslation(keys['cartSummary.prescription'])}</span>
                            <iframe
                                src={`${product.nameUrl}?hideStatus=true&newDesign=true&isMobile=${isMobileWidth}`}
                                scrolling="no"
                                sandbox="allow-same-origin"
                            />
                        </>
                    ) : (
                        <>
                            <div className="CooledProductsConflictEntry__Name">{product.name.mainName}</div>
                            <div className="CooledProductsConflictEntry__Description">{product.name.additionalName}</div>
                        </>
                    )}
                </div>
                <Info label={label} isCooled={product.isCooled} isSingleProduct />
            </div>
        </>
    );
};
